var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartbarngang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998046 24L0.998047 0L-0.00195307 -4.37114e-08L-0.00195411 24L0.998046 24Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00195334 7L-0.00195312 2L8.99805 2L8.99805 7L-0.00195334 7ZM0.829639 2.88825L0.829639 6.09741L8.16645 6.09741L8.16645 2.88825L0.829639 2.88825Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00195334 14L-0.00195312 9L12.998 9L12.998 14L-0.00195334 14ZM0.822169 9.88839L0.822169 13.1118L12.1606 13.1118L12.1606 9.88839L0.822169 9.88839Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00195334 21L-0.00195312 16L17.998 16L17.998 21L-0.00195334 21ZM0.832745 16.8882L0.832744 20.1118L17.1633 20.1118L17.1633 16.8882L0.832745 16.8882Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartbarngang);
export default __webpack_public_path__ + "static/media/chart bar ngang.6e9b3d3324de4b4c0ffd028dfaed3521.svg";
export { ForwardRef as ReactComponent };